
define("json!content/json/global.json", function(){ return {
  "buttons": {
    "home": "Menu",
    "exit": "Exit",
    "resources": "Resources",
    "caption": "Caption",
    "back": "‹‹",
    "next": "››",
    "play": "Play",
    "pause": "Pause"
  },
  "globalText": {
    "previousScoreText":"Previous High Score",
    "newScoreText":"New Score",
    "increaseScoreText":"Increase",
    "tutorialPrefix": "Tutorial &amp;"
  }
};});

